//* Libraries Imports
import moment from "moment";

//* Components Impots
import CondicoesEspeciaisBox from "./CondicoesEspeciaisBox";
import { Chip } from "@material-ui/core";
import { useHistory } from "react-router-dom";

function InscricaoHeader({ inscricao, onBackPath, onEvaluate, formatStatus }) {
  const statusColor =
    inscricao.statusAvaliacao === "deferida"
      ? "green"
      : inscricao.statusAvaliacao === "indeferida"
      ? "red"
      : inscricao.statusAvaliacao === "pendente"
      ? "orange"
      : "inherit";
  const navigate = useHistory();
  return (
    <>
      <div className="mb-3 d-flex justify-content-end">
        <a onClick={()=>{
          navigate.push(onBackPath)
        }} className="btn btn-secondary btn-sm">
          Voltar
        </a>
      </div>

      <div className="flex jcsb">
        <h4 className="header" style={{ color: "black" }}>
          Inscrição #{inscricao.id} – {inscricao.nomeCompleto}
        </h4>
      </div>

      <div
        style={{
          background: "#f7f9fc",
          border: "1px solid #e6e9ef",
          borderRadius: 8,
          padding: 16,
          marginBottom: 16,
        }}
      >
        <div className="row">
          <div className="col-md-8" style={{ marginBottom: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <Chip
                label={`Status: ${formatStatus(inscricao.statusAvaliacao)}`}
                style={{
                  backgroundColor: statusColor,
                  color: "white",
                  fontWeight: 600,
                }}
              />
              {inscricao.cpf && (
                <Chip
                  label={`CPF: ${inscricao.cpf}`}
                  variant="outlined"
                  style={{ borderColor: "#cbd5e1", color: "#0f172a" }}
                />
              )}
              <button
                disabled={inscricao.block}
                className="btn btn-sm btn-primary"
                style={{ color: "white" }}
                onClick={onEvaluate}
              >
                Avaliar inscrição
              </button>
            </div>
          </div>
          <div className="col-md-4" style={{ textAlign: "right" }}>
            <div style={{ fontSize: 12, color: "#475569" }}>
              Criado:{" "}
              {inscricao.createdAt && moment(inscricao.createdAt).isValid()
                ? moment(inscricao.createdAt).format("DD/MM/YYYY HH:mm")
                : "-"}
              {" · "}
              Atualizado:{" "}
              {inscricao.updatedAt && moment(inscricao.updatedAt).isValid()
                ? moment(inscricao.updatedAt).format("DD/MM/YYYY HH:mm")
                : "-"}
            </div>
          </div>
        </div>

        <CondicoesEspeciaisBox inscricao={inscricao} />
      </div>
    </>
  );
}

export default InscricaoHeader;